.input {
  --md-sys-color-primary: var(--pgm-sys-color-primary);
  --md-sys-color-on-surface: var(--pgm-sys-color-on-surface);
  --md-sys-color-on-surface-variant: var(--pgm-sys-color-on-surface-variant);
  --md-sys-color-outline: var(--pgm-sys-color-outline);
  --md-sys-color-error: var(--pgm-sys-color-error);
  --md-sys-color-on-error-container: var(--pgm-sys-color-on-error-container);
  --md-sys-color-surface-container-highest: var(--pgm-sys-color-surface-container-highest);
  --md-sys-typescale-body-large-font: var(--pgm-sys-typescale-body-large-font);
  --md-sys-typescale-body-large-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-sys-typescale-body-large-size: var(--pgm-sys-typescale-body-large-size);
  --md-sys-typescale-body-large-tracking: var(--pgm-sys-typescale-body-large-tracking);
  --md-sys-typescale-body-large-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-sys-typescale-body-small-font: var(--pgm-sys-typescale-body-small-font);
  --md-sys-typescale-body-small-line-height: var(--pgm-sys-typescale-body-small-line-height);
  --md-sys-typescale-body-small-size: var(--pgm-sys-typescale-body-small-size);
  --md-sys-typescale-body-small-tracking: var(--pgm-sys-typescale-body-small-tracking);
  --md-sys-typescale-body-small-weight: var(--pgm-sys-typescale-body-small-weight);

  --md-filled-text-field-container-color: var(--pgm-sys-color-surface-container-highest);
  --md-filled-text-field-active-indicator-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-text-field-hover-active-indicator-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-text-field-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-hover-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-focus-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-error-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-error-hover-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-error-focus-input-text-color: var(--pgm-sys-color-on-surface);
  --md-filled-text-field-input-text-placeholder-color: var(--pgm-sys-color-on-surface-variant);
  --md-filled-text-field-input-text-font: var(--pgm-sys-typescale-body-large-font);
  --md-filled-text-field-input-text-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-filled-text-field-input-text-size: var(--pgm-sys-typescale-body-large-size);
  --md-filled-text-field-input-text-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-filled-text-field-trailing-icon-size: 32px;
  --md-filled-text-field-leading-space: 12px;
  --md-filled-text-field-trailing-space: 12px;
  --md-filled-text-field-with-leading-icon-leading-space: 12px;
  --md-filled-text-field-with-trailing-icon-trailing-space: 12px;
  --md-filled-text-field-top-space: 16px;
  --md-filled-text-field-bottom-space: 16px;
  --md-filled-text-field-with-label-top-space: 8px;
  --md-filled-text-field-with-label-bottom-space: 8px;

  --md-outlined-text-field-outline-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-text-field-hover-outline-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-text-field-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-hover-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-focus-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-error-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-error-hover-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-error-focus-input-text-color: var(--pgm-sys-color-on-surface);
  --md-outlined-text-field-input-text-placeholder-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-text-field-input-text-font: var(--pgm-sys-typescale-body-large-font);
  --md-outlined-text-field-input-text-line-height: var(--pgm-sys-typescale-body-large-line-height);
  --md-outlined-text-field-input-text-size: var(--pgm-sys-typescale-body-large-size);
  --md-outlined-text-field-input-text-weight: var(--pgm-sys-typescale-body-large-weight);
  --md-outlined-text-field-trailing-icon-size: 32px;
  --md-outlined-text-field-leading-space: 12px;
  --md-outlined-text-field-trailing-space: 12px;
  --md-outlined-text-field-with-leading-icon-leading-space: 12px;
  --md-outlined-text-field-with-trailing-icon-trailing-space: 12px;
  --md-outlined-text-field-top-space: 16px;
  --md-outlined-text-field-bottom-space: 16px;
  --md-outlined-field-outline-label-padding: 4px;
  --md-outlined-field-label-text-padding-bottom: 8px;

  display: inline-flex;
  max-width: 100%;
}

.inputFullWidth {
  width: 100%;
}

.input:not([type="textarea"]) {
  height: 56px;
  max-height: 56px;
  min-height: 56px;
  overflow: visible;
  resize: none;
}

.inputIcon {
  display: block;
  font-size: 24px;
  height: 24px;
  line-height: 24px;
  width: 24px;
}

.clearButton {
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  background: transparent;
}


.clearIcon {
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 20;
}
